import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useCreateClientAdminUser() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Crée un administrateur (rôle ADMIN) du client. L'email d'invitation n'est
   * envoyé que si l'envoi d'emails est activé pour le client.
   * @param {number} clientId - L'identifiant du client
   * @param {{ first_name, last_name, email, phone_number }} user
   * @returns {Promise<object[]|null>} Les administrateurs du client, ou null en cas d'erreur
   */
  const createAdminUser = async (clientId, user) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.post(
        `/super-admin/clients/${clientId}/admin-users`,
        user
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      if (response.data?.invitation_sent) {
        toast.success(response.data.message);
      } else {
        toast.info(response.data?.message);
      }

      return response.data.admin_users;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createAdminUser,
  };
}
